import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import WhyStudents from './components/WhyStudents';
import Programs from './components/Programs';
import Testimonials from './components/Testimonials';
import ProgramFlexibility from './components/ProgramFlexibility';
import AddOns from './components/AddOns';
import HowItWorks from './components/HowItWorks';
import Guidelines from './components/Guidelines';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingChat from './components/FloatingChat';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <WhyStudents />
        <Programs />
        <Testimonials />
        <ProgramFlexibility />
        <AddOns />
        <HowItWorks />
        <Guidelines />
        <FAQ />
        <FinalCTA />
        <Contact />
      </main>
      <Footer />
      <FloatingChat />
    </div>
  );
}

export default App;
